import React, {useEffect, useState} from 'react';
import globalContext from '../src/config/context';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import './App.css';
import Config from '../src/config/config';

import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {idID} from '@material-ui/core/locale';

// import Auto from './views/Login/Auto';
// import Login from './views/Login/Login';
import Maps from './views/Maps/Maps';
import Custom from './views/Custom';
import Splashscreen from './views/Splashscreen';
import View360 from './views/view360';

import LoadingBackdrop from './component/Loading';
import Alert from './component/Alert';
import Test from './views/Test';

import Numeral from 'numeral';
import './assets/utils/numeral_id';

import moment from 'moment';
import 'moment/locale/id';

import localforage from 'localforage';

const App = ({navigation}) => {
  const [loading, setLoading] = useState(false);
  const [refreshLegend, setRefreshLegend] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [checkedPbb, setCheckedPbb] = React.useState(false);
  const [checkedBphtb, setCheckedBphtb] = React.useState(false);
  const [checkedHotel, setCheckedHotel] = React.useState(false);
  const [checkedRestoran, setCheckedRestoran] = React.useState(false);
  const [checkedHiburan, setCheckedHiburan] = React.useState(false);
  const [checkedReklame, setCheckedReklame] = React.useState(false);
  const [checkedPpj, setCheckedPpj] = React.useState(false);
  const [checkedParkir, setCheckedParkir] = React.useState(false);
  const [checkedPat, setCheckedPat] = React.useState(false);
  const [checkedWalet, setCheckedWalet] = React.useState(false);
  const [checkedMblb, setCheckedMblb] = React.useState(false);
  const [checkedPendataan, setCheckedPendataan] = React.useState(false);
  const [centroidLatitude, setCentroidLatitude] = useState('');
  const [centroidLongitude, setCentroidLongitude] = useState('');
  const [targetPendataan, setTargetPendataan] = useState('');
  const [zoomKelurahan, setZoomKelurahan] = useState('');
  const [zoomBlok, setZoomBlok] = useState('');
  const [zoomPersil, setZoomPersil] = useState('');
  const [pencarian, setPencarian] = useState({
    state: 'default',
    nop: '',
    tahun: '',
    kecamatan: '',
    kelurahan: '',
    blok: '',
  });

  localforage.config({
    storeName: 'citracom_gis',
  });

  const {AppContext} = globalContext;
  const theme = createMuiTheme({}, idID);
  Numeral.locale('id');
  moment.locale('id');

  return (
    <AppContext.Provider
      value={[
        {
          loading,
          refreshLegend,
          alert,
          pencarian,
          checkedPbb,
          checkedBphtb,
          checkedHotel,
          checkedRestoran,
          checkedHiburan,
          checkedReklame,
          checkedPpj,
          checkedParkir,
          checkedPat,
          checkedWalet,
          checkedMblb,
          checkedPendataan,
          centroidLatitude,
          centroidLongitude,
          targetPendataan,
          zoomKelurahan,
          zoomBlok,
          zoomPersil,
        },
        {
          setLoading,
          setRefreshLegend,
          setAlert,
          setPencarian,
          setCheckedPbb,
          setCheckedBphtb,
          setCheckedHotel,
          setCheckedRestoran,
          setCheckedHiburan,
          setCheckedReklame,
          setCheckedPpj,
          setCheckedParkir,
          setCheckedPat,
          setCheckedWalet,
          setCheckedMblb,
          setCheckedPendataan,
          setCentroidLatitude,
          setCentroidLongitude,
          setTargetPendataan,
          setZoomKelurahan,
          setZoomBlok,
          setZoomPersil,
        },
      ]}>
      <BrowserRouter basename={Config.homepage}>
        <ThemeProvider theme={theme}>
          <Switch>
            {/*<Route path="/auto" render={(props) => <Auto {...props} />} />*/}
            {/*<Route path="/login" render={(props) => <Login {...props} />} />*/}
            <Route path="/maps" render={(props) => <Maps {...props} />} />
            <Route path="/custom" render={(props) => <Custom {...props} />} />
            <Route path="/view360/:nop" render={(props) => <View360 {...props} />} />

            <Route path="/test" render={(props) => <Test {...props} />} />
            <Route path="/" render={(props) => <Splashscreen {...props} />} />
          </Switch>
        </ThemeProvider>
      </BrowserRouter>

      <LoadingBackdrop open={loading} />

      <Alert alert={alert} onClose={() => setAlert(null)} />
    </AppContext.Provider>
  );
};

export default App;
